import { __ANY_LINK } from 'customer-data-filters-ui/converters/listSegClassic/ListSegConstants';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const DisplayValueEmailLink = ({
  value
}) => value === __ANY_LINK ? /*#__PURE__*/_jsx(FormattedMessage, {
  message: "customerDataFiltersUI.customerDataFilters.FilterEditor.specialOptionValues.anyLink"
}) : /*#__PURE__*/_jsx("span", {
  children: value
});
export default DisplayValueEmailLink;